import { render } from "./DeveloperListComponent.vue?vue&type=template&id=f0d39d1a&scoped=true"
import script from "./DeveloperListComponent.vue?vue&type=script&lang=js"
export * from "./DeveloperListComponent.vue?vue&type=script&lang=js"

import "./DeveloperListComponent.vue?vue&type=style&index=0&id=f0d39d1a&scoped=true&lang=css"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-f0d39d1a"]])

export default __exports__